"use client";

import { useGSAP } from "@gsap/react";
import gsap from "gsap";
import { SplitText } from "gsap/all";
import { useRef, useEffect } from "react";
import { useMediaQuery } from "react-responsive";

interface HeroSectionProps {
  isLoading: boolean;
}

const HeroSection = ({ isLoading }: HeroSectionProps) => {
  const videoRef = useRef<HTMLVideoElement>(null);

  const isMobile = useMediaQuery({
    query: "(max-width: 768px)",
  });

  useGSAP(() => {
    const titleSplit = SplitText.create(".hero-title", {
      type: "words,chars",
    });

    const tl = gsap.timeline({
      delay: 1,
    });

    tl.to(".hero-content", {
      opacity: 1,
      y: 0,
      ease: "power1.inOut",
    })
      .to(
        ".hero-text-scroll",
        {
          duration: 1,
          clipPath: "polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)",
          ease: "circ.out",
        },
        "-=0.5"
      )
      .from(
        titleSplit.chars,
        {
          yPercent: 200,
          stagger: 0.02,
          ease: "power2.out",
        },
        "-=0.5"
      );

    const heroTl = gsap.timeline({
      scrollTrigger: {
        trigger: ".hero-container",
        start: "1% top",
        end: "bottom top",
        scrub: true,
      },
    });
    heroTl.to(".hero-container", {
      rotate: 7,
      scale: 0.9,
      yPercent: 30,
      ease: "power1.inOut",
    });

    return () => {
      titleSplit.revert();
    };
  });

  useEffect(() => {
    if (!isLoading && videoRef.current) {
      videoRef.current.play().catch(() => {
        // Ignore autoplay rejections.
      });
    }
  }, [isLoading, isMobile]);

  return (
    <section id="hero" className="bg-main-bg">
      <div className="hero-container">
        {isMobile ? (
          <video
            ref={videoRef}
            src="https://res.cloudinary.com/ddahd2kco/video/upload/v1770557434/0fgcpsrynnrmr0cw7npsb8h54c_result__varibp.mp4"
            autoPlay
            // loop
            muted
            playsInline
            preload="metadata"
            aria-hidden="true"
            tabIndex={-1}
            className="absolute inset-0 w-full h-full object-cover"
          >
            <track kind="captions" src="/captions/blank.vtt" srcLang="en" label="English" />
          </video>
        ) : (
          <video
            ref={videoRef}
            src="https://res.cloudinary.com/ddahd2kco/video/upload/v1770473006/bg-vid-kunafa_p37sqp.mp4"
            autoPlay
            // loop
            muted
            playsInline
            preload="metadata"
            aria-hidden="true"
            tabIndex={-1}
            className="absolute inset-0 w-full h-full object-cover"
          >
            <track kind="captions" src="/captions/blank.vtt" srcLang="en" label="English" />
          </video>
        )}
        <div className="hero-content opacity-0">
          <div className="overflow-hidden px-3 py-2 rounded-xl backdrop-blur-[2px] bg-white/10 ">
            <h1 className="hero-title ">
              {/* [-webkit-text-stroke:3px_#523122] */}
              Turkish&nbsp;Dessert + <br /> Indian&nbsp;Flavours
            </h1>
          </div>
          <div
            style={{
              clipPath: "polygon(50% 0, 50% 0, 50% 100%, 50% 100%)",
            }}
            className="hero-text-scroll"
          >
            <div className="hero-subtitle">
              <h1>Freaking Delicious</h1>
            </div>
          </div>


        </div>
      </div>
    </section>
  );
};

export default HeroSection;
